import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Input } from '../ui/input';

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

// Chip-style multi email input: type an address and press Enter / comma.
export const RecipientInput = ({ value, onChange, placeholder = 'name@company.com', testId = 'recipient-input' }) => {
  const [text, setText] = useState('');
  const [err, setErr] = useState('');
  const add = (raw) => {
    const parts = raw.split(/[,;\s]+/).map((s) => s.trim().toLowerCase()).filter(Boolean);
    const bad = parts.filter((p) => !EMAIL_RE.test(p));
    if (bad.length) { setErr(`Invalid: ${bad.join(', ')}`); return; }
    onChange([...new Set([...value, ...parts])]);
    setText(''); setErr('');
  };
  return (
    <div>
      <div className="flex flex-wrap gap-1.5 mb-1.5">
        {value.map((e) => (
          <span key={e} className="inline-flex items-center gap-1 text-xs bg-sky-50 text-sky-800 border border-sky-200 rounded-full px-2 py-0.5" data-testid={`${testId}-chip-${e}`}>
            {e}
            <button type="button" onClick={() => onChange(value.filter((x) => x !== e))} className="hover:text-red-600"><X className="h-3 w-3" /></button>
          </span>
        ))}
      </div>
      <Input
        value={text}
        placeholder={placeholder}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => { if (['Enter', ','].includes(e.key) && text.trim()) { e.preventDefault(); add(text); } }}
        onBlur={() => text.trim() && add(text)}
        data-testid={testId}
      />
      {err ? <p className="text-xs text-red-600 mt-1">{err}</p> : <p className="text-[11px] text-gray-400 mt-1">Press Enter or comma to add each address.</p>}
    </div>
  );
};
